<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('mailbox.mailings')">Newsletery i Mailingi</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      {{ mailing.title }}
    </h1>
    <div class="flex flex-wrap">
      <div class="bg-white rounded-md shadow overflow-hidden w-full lg:w-1/2">
        <form @submit.prevent="update">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

            <text-input v-model="form.title" :error="form.errors.title" class="pr-6 pb-8 w-full" label="Tytuł wiadomości" :disabled="form.is_for_send" />

            <text-input v-model="form.head_content" :error="form.errors.head_content" class="pr-6 pb-8 w-full" label="Nagłówek" :disabled="form.is_for_send" />

            <div class="pb-8 pr-6 w-full">
              <label class="form-label">Treść wiadomości:</label>
              <vue-editor v-model="form.content" :disabled="form.is_for_send" />

              <div class="w-1/2 form-error">
                <span v-if="form.errors.content">{{form.errors.content}}</span>
              </div>
            </div>

            <shtax-checkbox class="pr-6 pb-6 w-full" v-model:checked.sync="form.is_send_planned" :error="form.errors.is_send_planned" :checked="form.is_send_planned" label="Zaplanuj wysyłkę" :disabled="form.is_for_send" />

            <text-input v-model="form.start_sending_at_date" :error="form.errors.start_sending_at_date" class="pr-6 pb-8 w-full lg:w-1/2" label="Dzień wysyłki" type="date" :disabled="!form.is_send_planned || form.is_for_send" />
            <multiselect-input v-model="form.start_sending_at_time" :error="form.errors.start_sending_at_time" class="pr-6 pb-8 w-full lg:w-1/2" label="Godzina wysyłki" :options="hours" :multiple="false" :close_on_select="true" :isDisabled="!form.is_send_planned || form.is_for_send" />

            <shtax-checkbox class="pr-6 pb-6 w-full" v-model:checked.sync="form.is_sending_confirmed" :error="form.errors.is_sending_confirmed" :checked="form.is_sending_confirmed" label="Potwierdź przygotowanie do wysyłki" :disabled="!form.is_send_planned || form.start_sending_at_date == null || form.start_sending_at_time == null || form.is_for_send" />

            <multiselect-input v-model="form.filter" :error="form.errors.filter" class="pr-6 pb-8 w-full lg:w-full" label="Filtry wysyłki" :options="filters" track_by="key" opt_label="name" :multiple="false" :close_on_select="true" :isDisabled="form.is_for_send" />

            <multiselect-input v-model="form.clients" :error="form.errors.clients" class="pr-6 pb-8 w-full lg:w-full" label="Wybierz klientów z listy" :options="clients" track_by="id" opt_label="nazwa_pelna" :multiple="true" :close_on_select="false" v-if="form.filter != null && form.filter.key == 'send_only_to_choosen_clients'" :isDisabled="form.is_for_send" />

            <shtax-checkbox class="pr-6 pb-6 w-full" v-model:checked.sync="form.only_logged_user_clients" :error="form.errors.only_logged_user_clients" :checked="form.only_logged_user_clients" :label="'Tylko moich klientów ('+ mailing.user.first_name +' '+ mailing.user.last_name +')'" :disabled="form.is_for_send" />

            <multiselect-input v-model="form.users" :error="form.errors.users" class="pr-6 pb-8 w-full lg:w-full" label="Klienci opiekuna" :options="users" track_by="id" opt_label="name" :multiple="true" :close_on_select="false" :isDisabled="form.only_logged_user_clients || form.is_for_send" />

            <shtax-checkbox class="pr-6 pb-6 w-1/2" v-model:checked.sync="form.on_jdg" :error="form.errors.on_jdg" :checked="form.on_jdg" label="Tylko JDG" :disabled="form.on_companies || form.is_for_send || form.filter.key == 'send_only_to_choosen_clients'" />

            <shtax-checkbox class="pr-6 pb-6 w-1/2" v-model:checked.sync="form.on_companies" :error="form.errors.on_companies" :checked="form.on_companies" label="Tylko spółki" :disabled="form.on_jdg || form.is_for_send || form.filter.key == 'send_only_to_choosen_clients'" />

          </div>
          <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
            <button class="btn-shtax bg-red-500 border-red-500" tabindex="-1" type="button" @click="send" v-if="form.is_sending_confirmed && !form.is_for_send && $page.props.can['edit mailings']">
              <div v-if="form.processing" class="btn-spinner mr-2" />
              <fa v-else icon="paper-plane" fixed-width /> Rozpocznij wysyłkę według planu
            </button>
            <button class="btn-shtax bg-red-500 border-red-500" tabindex="-1" type="button" @click="stop" v-if="form.is_sending_confirmed && form.is_for_send && !mailing.is_sent && $page.props.can['edit mailings']">
              <div v-if="form.processing" class="btn-spinner mr-2" />
              <fa v-else icon="ban" fixed-width /> Zatrzymaj
            </button>
            <loading-button :loading="form.processing" class="btn-shtax ml-auto" type="submit" v-if="!form.is_for_send && $page.props.can['edit mailings']">Zmień dane newslettera</loading-button>
          </div>
        </form>
      </div>
    </div>

  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import ShtaxCheckbox from '@/ShtaxComponents/Checkbox'
import { VueEditor } from "vue2-editor";
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'
import Swal from 'sweetalert2'

export default {
  metaInfo: { title: 'Zmiana newsletera' },
  components: {
    LoadingButton,
    TextInput,
    ShtaxCheckbox,
    VueEditor,
    MultiselectInput
  },
  layout: Layout,
  props: {
    mailing: Object,
    filters: Array,
    clients: Array,
    users: Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        title: this.mailing.title,
        head_content: this.mailing.head_content,
        content: this.mailing.content,
        is_send_planned: this.mailing.is_send_planned,
        start_sending_at_date: this.mailing.start_sending_at != null ? this.mailing.start_sending_at.substring(0, 10) : null,
        start_sending_at_time: this.mailing.start_sending_at != null ? this.mailing.start_sending_at.substring(11, 16) : null,
        is_sending_confirmed: this.mailing.is_sending_confirmed,
        is_for_send: this.mailing.is_for_send,
        filter: this.mailing.filter,
        only_logged_user_clients: this.mailing.only_logged_user_clients,
        clients: this.mailing.choosen_clients,
        on_jdg: this.mailing.on_jdg,
        on_companies: this.mailing.on_companies,
        users: this.mailing.clients_by_user
      }),
      hours: [
        '0:00', '1:00', '2:00', '3:00', '4:00', '5:00', '6:00', '7:00', '8:00',
        '9:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', 
        '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'
      ]
    }
  },
  methods: {
    update() {
      if (this.form.filter != null && this.form.filter.key != 'send_only_to_choosen_clients')
        this.form.clients = null;

      if (this.form.only_logged_user_clients)
        this.form.users = null;

      this.form.put(this.route('mailbox.mailings.update', this.mailing.id))
    },
    send() {
      Swal.fire({
        title: 'Rozpocząć rzeczywistą wysyłkę?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Tak!',
        cancelButtonText: 'Nie'
      }).then((result) => {
        if (result.isConfirmed) {
          this.form.put(this.route('mailbox.mailings.send', this.mailing.id))
        }
      })
    },
    stop() {
      Swal.fire({
        title: 'Zatrzymać wysyłkę?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Tak!',
        cancelButtonText: 'Nie'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.put(this.route('mailbox.mailings.stop', this.mailing.id))
        }
      })
    },
  },

}
</script>
